function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__a",
  d: "M0 0.13L21.546 0.13 21.546 7.521 0 7.521z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.2 12) translate(0 18)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#008EC3",
  d: "M21.051.323c-.52-.35-1.223-.212-1.572.31-2.338 3.484-4.411 4.613-8.708 4.613-1.755 0-3.67-.286-5.215-1.087C4.08 3.389 3.084 1.969 2.1.623 1.73.118 1.02.006.515.376c-.506.368-.67.877-.354 1.418 1.064 1.826 2.38 3.341 4.167 4.273 1.844.958 4.35 1.521 6.443 1.448 4.707-.16 8.243-1.813 10.592-5.62.328-.532.21-1.224-.312-1.572",
  mask: "url(#prefix__b)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#231F20",
  d: "M3.576 16.78h6.41l.106-1.55H7.381s2.547-1.917 3.048-3.215c.472-1.207-.05-2.834-1.38-3.33-.991-.35-2.309-.078-3.141.51-.694.586-1.082 1.431-1.402 2.232H6.54c-.016-.471.16-1.242.802-1.348.45-.101.997.057 1.18.517.237.569.05 1.295-.274 1.754-1.388 1.655-4.672 4.43-4.672 4.43M15.132 13.708H13.25l2.397-3.116-.514 3.116zm.09-4.835l-4.143 5.063-.2 1.208h4.017l-.277 1.68h1.8l.277-1.68h1.012l.237-1.436h-1.012l.796-4.835h-2.506z",
  transform: "translate(13.2 12)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B7292F",
  d: "M9.153 6.027c.604.167 1.228-.193 1.393-.795l1.036-3.8C11.747.83 11.39.205 10.786.042c-.605-.167-1.229.191-1.393.794l-1.036 3.8c-.165.604.19 1.229.796 1.392M14.72 6.027c.605.167 1.229-.193 1.394-.795l1.038-3.8c.163-.602-.194-1.228-.799-1.391-.604-.167-1.228.191-1.392.794l-1.036 3.8c-.164.604.19 1.229.796 1.392",
  transform: "translate(13.2 12)"
}));

function SvgYes24On(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes24On);
export default __webpack_public_path__ + "static/media/yes24-on.8b4524d6.svg";
export { ForwardRef as ReactComponent };